export default __webpack_public_path__ + "static/media/completeProfile.7ff40eaf.png";